import { Redirect, Stack } from 'expo-router'
import { useIsAdmin } from '@/hooks/useUserRoles'

export default function () {
  const isAdmin = useIsAdmin()

  if (!isAdmin) {
    return <Redirect href="/(root)/(tabs)" />
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        gestureEnabled: false
      }}
    />
  )
}
